module.exports = __webpack_public_path__ + "static/media/1.37dc0212.svg";